import { ChangeEventHandler, HTMLInputTypeAttribute } from 'react';

import { TextField, TextFieldProps } from '@mui/material';

import styles from './styles';

type Props = {
  name: string;
  label: string;
  value: string;
  type?: HTMLInputTypeAttribute;
  required?: boolean;
  disabled?: boolean;
  inputProps?: TextFieldProps['inputProps'];
  onChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
};

const CustomTextField = ({
  name,
  label,
  value,
  required = false,
  disabled = false,
  type = 'text',
  inputProps,
  onChange,
}: Props) => {
  return (
    <TextField
      name={name}
      label={label}
      value={value}
      onChange={onChange}
      fullWidth
      sx={styles.textField}
      size="small"
      required={required}
      type={type}
      disabled={disabled}
      inputProps={inputProps}
    />
  );
};

export default CustomTextField;
